module.exports = __webpack_public_path__ + "img/truck_mounted_forklifts.1ec96e3a.jpg";